<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Relatório do Mês"
        :data="MonthReport.data"
        :columns="columns"
        row-key="id"
        :loading="$apollo.loading"
        :pagination.sync="pagination"
        @request="onRequest"
      >
        <template v-slot:top="props">
          <div class="row col-11 q-col-gutter-xs">
            <div class="col-12 text-center text-h3">Relatório do Mês</div>
          </div>
          <div class="col-1 text-center">
            <q-btn color="bg-purple-10" outline icon="add" @click="$router.push({name:'donator.new'})"></q-btn>
          </div>
        </template>

        <template v-slot:body-cell-options="value">
          <q-td>
          <!--<q-btn round color="primary" @click="mudaComboOption(value)" icon="visibility"/>-->
          </q-td>
        </template>

      </q-table>
    </div>
  </q-page>
</template>

<script>
import { MONTH_REPORT } from '../graphql/graphql'
import { DateTime } from 'luxon'

export default {
  name: 'MonthReport',
  data () {
    return {
      opened: false,
      MonthReport: {
        data: [],
        paginatorInfo: {
          total: 0
        }
      },
      loading: true,
      columns: [
        {
          name: 'name',

          label: 'Nome do relatório do mês',
          align: 'left',
          field: 'name', /*,                        format: val => {
                            return `<a href="http://www.google.com">${val}</a>`
                        } */
          required: true
        }, {
          name: 'file',

          label: 'Arquivo',
          align: 'left',
          field: 'file'

        }, {
          name: 'sent_at',

          label: 'Agendado para',
          align: 'left',
          field: 'sent_at',

          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString()
          }
        }
      ],
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 3,
        rowsNumber: 3
      },
      alert: false,
      loadingDonations: false,
      donator_name: '',
      donator_id: ''
    }
  },
  apollo: {
    MonthReport: {
      query: MONTH_REPORT,
      variables () {
        return {
          page: this.pagination.page,
          count: this.pagination.rowsPerPage,
          orderBy: [{ field: 'id', order: 'DESC' }]
        }
      },
      skip: true
      // pollInterval: 300, // ms
    }
  },
  watch: {
    alert (oldVal, newVal) {
      this.loadingDonations = !this.alert
    }
  },
  methods: {

    onRequest (props) {
      /* console.log('on request') */

      /* this.pagination.rowsNumber = this.donatorsByString2.paginatorInfo.total
                this.$apollo.queries.donatorsByString2.setVariables({
                    'page': props.pagination.page || 1,
                    'count': props.pagination.rowsPerPage || 3,
                    'payment_form_id': this.formaPagamento,
                    'donator_status_id': this.statusDoador,
                    'donator_type_id': this.tipoDoador,
                    'shipping_method_id': this.formaEnvio,
                    orderBy: [{field: 'full_name', order: 'ASC'}]
                })
                this.$apollo.queries.donatorsByString2.refetch().then(result => {
                    this.pagination.rowsNumber = result.data.donatorsByString2.paginatorInfo.total
                }) */

      this.pagination.page = props.pagination.page
      this.pagination.rowsPerPage = props.pagination.rowsPerPage
      this.donators = this.donatorsByString
      this.pagination.rowsNumber = this.donatorsByString2.paginatorInfo.total
      this.$apollo.addSmartQuery('donatorsByString2', {
        query: MONTH_REPORT,
        variables () {
          return {
            'page': props.pagination.page || 1,
            'count': props.pagination.rowsPerPage || 3,
            orderBy: [{ field: 'id', order: 'DESC' }]
          }
        }
      })
    }
  },
  mounted () {
    this.$apollo.queries.MonthReport.skip = false
    this.$apollo.queries.MonthReport.refetch().then(result => this.pagination.rowsNumber = result.data.MonthReport.paginatorInfo.total)
  }
}
</script>
<style>
  .q-table__top,
  .q-table__bottom,
  .q-icon,
  thead tr:first-child th {

    background-color: #590a7f;
    color: #ffffff !important;
  }

  .q-table__middle {
    max-height: 600px;
  }

  thead tr:first-child th {
    position: sticky;
    top: 0;
    opacity: 1;
    z-index: 1;
  }

  .row {
    margin: 0;
  }

  input[type='text'].inputSearch {
    color: white !important;
  }

  .q-table__top {
    border-bottom: 3px solid white;
  }
</style>
